import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error (benign error from Framer Motion / Wistia)
if (typeof window !== 'undefined') {
  const hideOverlay = () => {
    document.querySelectorAll('iframe[src*="overlay"]').forEach(el => el.remove());
    document.querySelectorAll('#webpack-dev-server-client-overlay-div, #webpack-dev-server-client-overlay').forEach(el => el.remove());
  };

  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      hideOverlay();
    }
  });

  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      hideOverlay();
    }
  });

  const observer = new MutationObserver(() => {
    const overlay = document.querySelector('#webpack-dev-server-client-overlay-div');
    if (overlay && overlay.textContent && overlay.textContent.includes('ResizeObserver')) {
      overlay.remove();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
